.btnReadMore {
  font-family: 'Raleway', sans-serif;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 1px;
  display: inline-block;
  padding: 14px 32px;
  border-radius: 4px;
  transition: 0.5s;
  line-height: 1;
  color: #fff;
  animation-delay: 0.8s;
  background: #d9232d;
}

.btnReadMore:hover {
  background: #e1444d;
  color: #fff;
}
